/**
 * 下面是来源自软件端的说明：
 *
 * @brief configType用于标识配置类型
 * @details
 * 1:网吧设备,1个出厂配置(超级管理员、管理员权限)、1个用户配置(用户权限)
 * 2:网吧54设备,4个出厂配置(超级管理员、管理员权限)、4个用户配置(用户权限)
 * 3:网吧ESK900系列设备,4个配置,其中第一个配置为出厂配置
 *
 * int m_configType;
 */

import { RoleId } from '@rapoo/device-sdk'

export const cafeConfigSlots = [
  {
    id: 0,
    roles: [RoleId.user],
  },
  {
    id: 1,
    roles: [RoleId.superAdmin, RoleId.admin],
  },
]

export const cafe54ConfigSlots = [
  {
    id: 0,
    roles: [RoleId.user],
  },
  {
    id: 1,
    roles: [RoleId.user],
  },
  {
    id: 2,
    roles: [RoleId.user],
  },
  {
    id: 3,
    roles: [RoleId.user],
  },
  {
    id: 4,
    roles: [RoleId.superAdmin, RoleId.admin],
  },
  {
    id: 5,
    roles: [RoleId.superAdmin, RoleId.admin],
  },
  {
    id: 6,
    roles: [RoleId.superAdmin, RoleId.admin],
  },
  {
    id: 7,
    roles: [RoleId.superAdmin, RoleId.admin],
  },
]

export const esk900ConfigSlots = [
  {
    id: 0,
    roles: [RoleId.superAdmin, RoleId.admin, RoleId.user],
  },
  {
    id: 1,
    roles: [RoleId.user],
  },
  {
    id: 2,
    roles: [RoleId.user],
  },
  {
    id: 3,
    roles: [RoleId.user],
  },
]
